var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-badge',{attrs:{"max":_vm.max,"type":_vm.type,"value":_vm.fvalue,"is-dot":_vm.fIsDot,"hidden":_vm.hidden}})
}
var staticRenderFns = []

export { render, staticRenderFns }